import React, { useState, useEffect, useRef } from "react";
import { BarChart, CartesianGrid, Bar, XAxis, YAxis, Label, ResponsiveContainer } from "recharts";
import { startOfHour, parseISO, format } from "date-fns";
import { i18n } from "../../translate/i18n";
import Title from "./Title";
import useTickets from "../../hooks/useTickets";

const HOURS = Array.from({ length: 24 }, (_, i) => ({
  time: `${String(i).padStart(2, "0")}:00`,
  amount: 0,
}));

const Chart = () => {
  const date = useRef(new Date().toISOString());
  const { tickets } = useTickets({ date: date.current });
  const [chartData, setChartData] = useState(HOURS);

  useEffect(() => {
    setChartData((prev) => {
      const next = prev.map((slot) => ({ ...slot, amount: 0 }));
      tickets.forEach((ticket) => {
        const hour = format(startOfHour(parseISO(ticket.createdAt)), "HH:mm");
        const slot = next.find((s) => s.time === hour);
        if (slot) slot.amount++;
      });
      return next;
    });
  }, [tickets]);

  return (
    <div className="w-full h-full flex flex-col">
      <Title>{`${i18n.t("dashboard.charts.perDay.title")}${tickets.length}`}</Title>
      <div className="w-full h-64 relative">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData} barSize={40} margin={{ top: 16, right: 16, bottom: 0, left: 24 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis dataKey="time" stroke="#94a3b8" tick={{ fontSize: 11 }} />
            <YAxis type="number" allowDecimals={false} stroke="#94a3b8" tick={{ fontSize: 11 }}>
              <Label angle={270} position="left" style={{ textAnchor: "middle", fill: "#64748b", fontSize: 12 }}>
                Tickets
              </Label>
            </YAxis>
            <Bar dataKey="amount" fill="#4f46e5" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default Chart;
